/**
 * The Dashboard is the one chunk every signed-in session needs. Naming its import here lets the
 * boot sequence and the login page start downloading it while they wait on the server, instead of
 * after — the router's lazy() and these prefetches share one module promise, so nothing is fetched
 * twice.
 */
export const loadDashboard = () => import('./components/Dashboard');
